import { CheckIcon } from 'lucide-react';

import { Card, ContentWrapper, Icon, Image, ImageWrapper, Name } from './item.styles';

import useI18nText from '../../../../../../hooks/useI18nText';

import type { Place } from '@rewardopl/types';

type ItemProps = {
  isSelected: boolean;
  onClick: () => void;
  place: Place;
};

export default function Item({ isSelected, onClick, place }: ItemProps) {
  const { name, name_i18n: nameI18n, picture } = place;

  const nameString = useI18nText(nameI18n, name);

  return (
    <Card as="button" isSelected={isSelected} onClick={onClick} title={nameString}>
      {picture ? (
        <ImageWrapper>
          <Image alt={nameString} src={`/api/uploads/${picture}`} />
        </ImageWrapper>
      ) : null}
      <ContentWrapper>
        <Name>{nameString}</Name>
        <Icon>
          <CheckIcon color={isSelected ? 'var(--primary)' : 'transparent'} />
        </Icon>
      </ContentWrapper>
    </Card>
  );
}
